<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>



        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="pageTitle" id="pageTitle" type="text" pInputText>
            <label for="pageTitle">Page Title</label>
            @for (validation of validationMessages.pageTitle; track validation) {
              <span>
                @if (form1.get('pageTitle').hasError(validation.type) && (form1.get('pageTitle').dirty || form1.get('pageTitle').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="linkDescription" id="pageTitle" type="text" pInputText>
            <label for="linkDescription">Link Description</label>
            @for (validation of validationMessages.linkDescription; track validation) {
              <span>
                @if (form1.get('linkDescription').hasError(validation.type) && (form1.get('linkDescription').dirty || form1.get('linkDescription').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="pageStartDate" inputId="pageStartDate" appendTo="body">
            </p-calendar>
            <label for="pageStartDate">Page Start Date</label>
            @for (validation of validationMessages.pageStartDate; track validation) {
              <span>
                @if (form1.get('pageStartDate').hasError(validation.type) && (form1.get('pageStartDate').dirty || form1.get('pageStartDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="pageEndDate" inputId="pageEndDate" appendTo="body">
            </p-calendar>
            <label for="pageEndDate">Page End Date</label>
            @for (validation of validationMessages.pageEndDate; track validation) {
              <span>
                @if (form1.get('pageEndDate').hasError(validation.type) && (form1.get('pageEndDate').dirty || form1.get('pageEndDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <!-- <textarea formControlName="pageHtml" id="pageHtml" [rows]="2" pInputTextarea></textarea> -->

            <!-- <ckeditor [editor]="editor" formControlName="pageHtml" id="pageHtml" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="pageHtml"
              id="pageHtml"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>


            <label for="pageHtml">Page HTML</label>
            @for (validation of validationMessages.pageHtml; track validation) {
              <span>
                @if (form1.get('pageHtml').hasError(validation.type) && (form1.get('pageHtml').dirty || form1.get('pageHtml').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>




        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="pageText" id="pageText" [rows]="2" pInputTextarea></textarea>
            <label for="pageText">Page Text</label>
            @for (validation of validationMessages.pageText; track validation) {
              <span>
                @if (form1.get('pageText').hasError(validation.type) && (form1.get('pageText').dirty || form1.get('pageText').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (articleId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Article</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!articleId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Article</button>
              }

              @if (articleId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Article</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>